// Pulls in all other .js files in this same directory.
const requireModule = require.context('.', true, /\.js$|\.js.erb$/);
requireModule.keys()
  .filter(filename => filename !== './index.js')
  .forEach(requireModule);
